import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  CommandButton,
  DetailsListLayoutMode,
  MessageBar,
  MessageBarType,
  SelectionMode,
  Stack,
  StackItem,
  TextField,
} from '@fluentui/react';
import { Page } from '../Page';
import { CommandBar } from '../CommandBar';
import { Container } from '../Container';
import { opportunitiesFields } from '../../enums/opportunitiesFields';
import { opportunitiesFilterables } from '../../enums/opportunitiesFilterables';
import DetailsListWithContextMenu from '../DetailsListWithContextMenu';
import { useFilterList } from '../../hooks/useFilterList';
import { useBreadcrumbs } from '../../providers/BreadcrumbsProvider';
import { useToast } from 'providers/ToastContextProvider';
import {
  useOpportunitiesLists,
  getOpportunitiesContextualMenu,
} from '../../hooks/useOpportunities';
import withAccess from '../../hocs/withAccess';
import { opportunityPermissions } from '../../enums/permissions';
import './OpportunitiesPage.css';

export const OpportunitiesPage: React.FC = () => {
  const history = useHistory();
  const { setBreadcrumbs } = useBreadcrumbs();
  const { opportunities = [] } = useOpportunitiesLists();
  const { toastSuccessMessage } = useToast();
  const menu = getOpportunitiesContextualMenu();
  const [searchQuery, setSearchQuery] = useState('');
  const { filteredList } = useFilterList(opportunities, searchQuery);

  useEffect(() => {
    setBreadcrumbs([]);
  }, [history]);

  return (
    <Page>
      <CommandBar />
      <Container mt={-5}>
        <header>
          <h2>Opportunities</h2>
          <CommandButton
            iconProps={{ iconName: 'Add' }}
            text="New Opportunity"
            onClick={() => history.push('/opportunities/new')}
          />
        </header>
        <Stack horizontal style={{ marginBottom: 16 }}>
          <StackItem>
            <TextField
              value={searchQuery}
              style={{ minWidth: 300 }}
              onChange={(_: any, value: any) => {
                setSearchQuery(value);
              }}
            />
          </StackItem>
        </Stack>
        {toastSuccessMessage && (
          <div style={{ marginBottom: 16 }}>
            <MessageBar
              messageBarType={MessageBarType.success}
              isMultiline={false}
            >
              {toastSuccessMessage}
            </MessageBar>
          </div>
        )}
        <div className="da-details-list-container opportunities-grid">
          {opportunities && (
            <DetailsListWithContextMenu
              columns={opportunitiesFields}
              items={filteredList}
              selectionMode={SelectionMode.none}
              onActiveItemChanged={(item) =>
                item && history.push(`/opportunities/${item.id}/edit`)
              }
              contextMenu={menu}
              filterableColumns={opportunitiesFilterables}
              layoutMode={DetailsListLayoutMode.fixedColumns}
            />
          )}
        </div>
      </Container>
    </Page>
  );
};

export default withAccess(
  {
    permisionAll: opportunityPermissions.editAll,
    permissionMe: opportunityPermissions.editMe,
  },
  OpportunitiesPage
);
